// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__A5IBC"};